import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    path: {
      title: 'Ścieżka',
      type: 'string',
      fieldRequired: false
    },
    active: {
      title: 'Aktywny',
      type: 'boolean',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
